<script>
import { defineComponent, ref, computed } from 'vue'

export default defineComponent({
  name: 'StaticImage',
  props: {
    data: { type: Object, required: true },
    alt: { type: String, default: undefined },
    cover: { type: Boolean, default: false },
    contain: { type: Boolean, default: false },
    useHeight: { type: Boolean, default: false }
  },
  setup (props) {
    return {
      loaded: ref(false),
      lazySrc: computed(() => `data:image/svg+xml,%3Csvg%20viewBox%3D%220%200%20${props.data.width}%20${props.data.height}%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Crect%20x%3D%220%22%20y%3D%220%22%20width%3D%22${props.data.width}%22%20height%3D%22${props.data.height}%22%20fill%3D%22${encodeURIComponent(props.data.color)}%22%20%2F%3E%3C%2Fsvg%3E`)
    }
  }
})
</script>

<template>
  <div>
    <transition>
      <img
        v-if="!loaded && data.ext !== 'png'"
        loading="lazy"
        decoding="async"
        draggable="false"
        role="presentation"
        class="pre-image"
        :class="{cover, contain, height: !!useHeight, width: !useHeight}"
        :src="lazySrc"
        :width="data.width"
        :height="data.height"
      />
    </transition>

    <img
      loading="lazy"
      decoding="async"
      draggable="false"
      class="main-image"
      :alt="alt"
      :role="!!alt ? undefined : 'presentation'"
      :class="{cover, contain, loaded, height: !!useHeight, width: !useHeight}"
      :src="data.src"
      :width="data.width"
      :height="data.height"
      @load="loaded = true"
    />
    <slot />
  </div>
</template>

<style lang="scss" scoped>
div {
  position: relative;
  width: 100%;
  height: 100%;
  isolation: isolate;
  transition: background-color 0.3s;
}

img {
  position: relative;
  z-index: 1;
  pointer-events: none;
  -moz-user-drag: none;
  user-select: none;
}

.main-image {
  opacity: 0;
  transition: opacity 0.3s;
}

.pre-image {
  position: absolute;
  z-index: 0;
}

.height {
  width: auto;
  max-width: none;
  height: 100%;
}

.width {
  width: 100%;
  height: auto;
}

img.loaded {
  opacity: 1;
}

.cover,
.contain {
  width: 100%;
  height: 100%;
}

.cover {
  object-fit: cover;
}

.contain {
  object-fit: contain;
}
</style>
